import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuscarModuloPipe } from './buscar-modulo.pipe';
import { GroupByPipe } from './groupBy.pipe';
import { OrderByPipe } from './orderBy.pipe';
import { BuscarPipe } from './buscar.pipe';
import { BuscarPedidoPipe } from './buscarPedido.pipe';
import { FormatoFechaPipe } from './formato-fecha.pipe';
import { TranscurridoPipe } from './transcurrido.pipe';
import { NumeroLetraPipe } from './numero-letra.pipe';
import { KeysPipe } from "./key.pipe";
import { SafePipe } from "./safe.pipe";

import { NgInit } from '../directives/ng-init.directive';
import { GetPrimerString } from './splitFirst.pipe.';
@NgModule({
  imports: [CommonModule],
  exports: [
    GetPrimerString,
    BuscarModuloPipe,
    GroupByPipe,
    OrderByPipe,
    BuscarPipe,
    BuscarPedidoPipe,
    FormatoFechaPipe,
    TranscurridoPipe,
    NumeroLetraPipe,
    KeysPipe,
    SafePipe,
    NgInit
  ],
  declarations: [
    GetPrimerString,
    BuscarModuloPipe,
    GroupByPipe,
    OrderByPipe,
    BuscarPipe,
    BuscarPedidoPipe,
    FormatoFechaPipe,
    TranscurridoPipe,
    NumeroLetraPipe,
    KeysPipe,
    SafePipe,
    NgInit
  ]
})
export class PipesModule {}
